<svg class="spinner" viewBox="0 0 50 50" [style.width]="diameterWithUnits()" [style.height]="diameterWithUnits()">
  <circle class="path" cx="25" cy="25" r="20" fill="none" [class]="strokeColor()" [attr.stroke-width]="strokeWidthWithUnits()"></circle>
</svg>
